import { apiGet } from './api'
import { BRANCHES } from './branches'

export interface Session {
  displayName: string
  linked: boolean
  username: string | null
  name: string | null
  companyCode: string | null
  isAdmin: boolean
}

const EMPTY: Session = {
  displayName: '',
  linked: false,
  username: null,
  name: null,
  companyCode: null,
  isAdmin: false,
}

let session: Session | null = null

/** โหลดสถานะผูกบัญชีครั้งเดียวตอนบูต */
export async function loadSession(): Promise<void> {
  try {
    session = { ...EMPTY, ...(await apiGet<Partial<Session>>('/me')) }
  } catch {
    session = { ...EMPTY }
  }
}

export function getSession(): Session {
  return session ?? { ...EMPTY }
}

export function isLinked(): boolean {
  return !!session?.linked
}

export function isAdmin(): boolean {
  return !!session?.isAdmin
}

export function linkedUsername(): string {
  return session?.username ?? ''
}

export function linkedName(): string {
  return session?.name ?? ''
}

/** "bungon.l — บังอร หลวงภักดี" สำหรับแสดงในฟอร์ม */
export function linkedLabel(): string {
  const u = linkedUsername()
  const n = linkedName()
  return n ? `${u} — ${n}` : u
}

/** map company_code (เช่น "PWC01") → รายการใน BRANCHES ("01 กาฬสินธุ์") — '' ถ้าจับคู่ไม่ได้ */
export function linkedBranch(): string {
  const code = (session?.companyCode ?? '').replace(/\D/g, '').slice(-2)
  if (!code) return ''
  return BRANCHES.find((b) => b.startsWith(code + ' ')) ?? ''
}

/** อัปเดต session ในเครื่องหลังผูกบัญชีสำเร็จ (ไม่ต้อง reload) */
export function setLinked(username: string, name: string | null, companyCode: string | null = null): void {
  session = { ...getSession(), linked: true, username, name, companyCode }
}
